<!-- Loading screen while http request in process. loading screen hide after http request completed. -->
<div *ngIf="showLoading">
<div *ngIf="loadingScreenService.isLoading | async;">
  <div class="his-loading-image" style="display: block" id='hisLoading'>
    <img style="margin-top: 60px;width: 120px; height: 120px;"
      src="../../../../../themes/theme-default/images/loading-child.gif" />
    <p style="font-size: 24px;color: #fff;"><b>Loading.. Please wait...</b></p>
  </div>
</div>
</div>
